import {Icon} from 'antd';

/**
 * 自定义图标
 * @type {Reactexport const SFC<IconProps>}
 */
export const YgIcon = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1568176_ezyw0dq117b.js',
});

export const fontSize = '28px';
export const fontSize2 = '18px';
export const color = '#ccc';
export const color1Y = '#2e549b';
export const color2Y = '#207440';
export const color3Y = '#d64526';
export const color4Y = '#D34899';
export const color4YDeep = '#692c72';
export const color5Y = '#ffaf25';